import { UPLOADS, ebook } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  'transform-better-e-book',
  'Transform Better E-Book',
  `${UPLOADS}/2023/08/digitopia-transformbetter-sm-02-400x400.webp`,
  { confirmed: true, href: '/en/impact-labs/ebooks/transform-better-e-book' },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 16
